"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPersonalAccessToken = void 0;
var nanoid_1 = require("nanoid");
var createPersonalAccessToken = function () { return "pat_".concat((0, nanoid_1.nanoid)(20)); };
exports.createPersonalAccessToken = createPersonalAccessToken;
